<template>
  <div>
    <div class="history-wrapper">
      <h4 class="history-heading">過往搜尋</h4>

      <div
        v-for="item in historyList"
        :key="item.id"
        class="history-item-wrapper"
      >
        <HistoryItem
          :item="item"
        />
      </div>
    </div>

    <div class="spacer-10"></div>
    <div class="separator"></div>
  </div>
</template>

<script>
import HistoryItem from "./HistoryItem";
import {mapActions, mapState} from "vuex";

export default {
  name: "HistoryHome",
  components: {HistoryItem},

  computed: {
    ...mapState('history', [
      'historyList',
    ]),
  },
  methods: {
    ...mapActions('history', [
      'getHistoryList',
    ]),
  },

  mounted() {
    this.getHistoryList();
  }

}
</script>

<style scoped>
.history-heading {
  margin: 16px 0;
}

h4.history-heading {
  font-size: 120%;
}
</style>
